import React from "react";
import FormPrint from "./FormPrint";
import rahel from "./../../../img/rahel1.jpg";
import { ProductConsumer } from "../../../Context/AddProWakel";
const InputPrint = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { RP_from, RP_to } = value;
          return (
            <>
              <img src={rahel} alt="rahel" />
              <div className="row mb2">
                <div className="col-4 text-right form-inline "></div>
                <div className="col-4 text-right form-inline ">
                  <div className="form-group ">
                    <label className="font-weight-bold f3 ml5">
                      ڕاپۆرتی پارەی نەگەڕاوە
                    </label>
                  </div>
                </div>
                <div className="col-4 text-right form-inline"></div>
              </div>

              <div
                className="row text-dark font-weight-bold f3 mx-4"
                style={{ border: "2px solid black" }}
              >
                <div className="col-5 text-right  form-inline ">
                  <div className="form-group">
                    <h5 className="font-weight-bold mt1 ml5 ">{RP_to}</h5>
                    <label className="font-weight-bold mb-2 ml1">
                      : بۆ بەرواری
                    </label>
                  </div>
                </div>

                <div className="col-5 text-right  form-inline ">
                  <div className="form-group">
                    <h5 className="font-weight-bold mt1 ml5  ">{RP_from}</h5>
                    <label className="font-weight-bold mb-2  ml1">
                      : لە بەرواری{" "}
                    </label>
                  </div>
                </div>
                {/* <div className="col-1 text-right  form-inline"></div> */}
              </div>

              <div className="mt4"></div>
              <FormPrint />
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default InputPrint;
